import React from "react";

import { useHistory } from "react-router-dom";

import ROUTES from "manager/config/routes";
import Icon from "shared/components/Icon";
import InfoPage from "shared/templates/InfoPage";

export const DealNotFound = () => {
  const history = useHistory();

  return (
    <InfoPage
      title="Deal Not Found"
      description="The deal ID you entered does not exist."
      MainIcon={Icon.Error404Icon}
      button={{
        children: "Back to Deals",
        PrefixIcon: Icon.ButtonBackArrowIcon,
        onClick: () => history.push(ROUTES.deals),
      }}
      width="900px"
    />
  );
};
